import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { MaterialUUID } from '../../../materialsTypes';

import {
  FETCH_MATERIAL_DOWNLOAD_URLS_QUERY,
  FetchMaterialDownloadUrlsQueryResponse
} from '../../../queries/fetchMaterialDownloadUrls.query';

import { useShowMaterial } from '../../../hooks/useShowMaterial';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { MaterialCache } from '../../../MaterialCache';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadMaterialSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  materialUuid: MaterialUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadMaterialSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  materialUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadMaterialSeparatelyButtonProps & GADataType) {
  const { materialLoading, refetchMaterial, materialError } =
    useShowMaterial<FetchMaterialDownloadUrlsQueryResponse>({
      cacheKey: MaterialCache.downloadUrls(materialUuid),
      options: {
        enabled: false,
        enabledPlaceholder: false
      },
      query: FETCH_MATERIAL_DOWNLOAD_URLS_QUERY,
      uuid: materialUuid
    });

  useShowToastOnErrorChange({ error: materialError });

  return (
    <DownloadUrlsModalButton<'material'>
      className={className}
      dataGa={dataGa}
      disabled={materialLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchMaterial}
      scope="material"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadMaterialSeparatelyButton;
